module.exports = __webpack_public_path__ + "c1be24bf33d6035153c683672f5f9abd.svg";